<template>
    <div>
        <NavbarOne/>

        <div class="flex items-center gap-4 flex-wrap bg-overlay p-14 sm:p-16 before:bg-title before:bg-opacity-70" :style="{backgroundImage:'url(' + bg + ')'}">
            <div class="text-center w-full">
                <h2 class="text-white text-8 md:text-[40px] font-normal leading-none text-center">Edit Account</h2>
                <ul class="flex items-center justify-center gap-[10px] text-base md:text-lg leading-none font-normal text-white mt-3 md:mt-4">
                    <li><router-link to="/index-v2">Home</router-link></li>
                    <li>/</li>
                    <li class="text-primary">Account</li>
                </ul>
            </div>
        </div>

        <div class="s-py-100" data-aos="fade-up">
            <div class="container-fluid">
                <div class="max-w-[1720px] mx-auto flex items-start gap-8 md:gap-12 2xl:gap-24 flex-col md:flex-row my-profile-navtab">
                    <div class="w-full md:w-[200px] lg:w-[300px] flex-none">
                        <ProfileTab/>
                    </div>
                    <div class="w-full md:w-auto md:flex-1 overflow-auto">
                        <form class="w-full max-w-[951px] bg-[#F8F8F9] dark:bg-dark-secondary p-5 sm:p-8 lg:p-[50px]" @submit.prevent="saveChanges">
                            <div class="flex items-start flex-col lg:flex-row gap-5 sm:gap-6">
                                <div class="grid gap-5 sm:gap-6 w-full lg:w-1/2">
                                    <div>
                                        <label class="text-base md:text-lg text-title dark:text-white leading-none mb-2 sm:mb-3 block">Full Name</label>
                                        <input v-model="form.name" class="w-full h-12 md:h-14 bg-white dark:bg-dark-secondary border border-[#E3E5E6] text-title dark:text-white focus:border-primary p-4 outline-none duration-300" type="text" placeholder="Enter your full name">
                                    </div>
                                    <div>
                                        <label class="text-base md:text-lg text-title dark:text-white leading-none mb-2 sm:mb-3 block">Designation</label>
                                        <input v-model="form.designation" class="w-full h-12 md:h-14 bg-white dark:bg-dark-secondary border border-[#E3E5E6] text-title dark:text-white focus:border-primary p-4 outline-none duration-300" type="text" placeholder="Enter your designation">
                                    </div>
                                    <div>
                                        <label class="text-base md:text-lg text-title dark:text-white leading-none mb-2 sm:mb-3 block">Phone No.</label>
                                        <input v-model="form.phone" class="w-full h-12 md:h-14 bg-white dark:bg-dark-secondary border border-[#E3E5E6] text-title dark:text-white focus:border-primary p-4 outline-none duration-300" type="text" placeholder="Type your phone number">
                                    </div>
                                    <div>
                                        <label class="text-base md:text-lg text-title dark:text-white leading-none mb-2 sm:mb-3 block">Mail</label>
                                        <input v-model="form.email" class="w-full h-12 md:h-14 bg-white dark:bg-dark-secondary border border-[#E3E5E6] text-title dark:text-white focus:border-primary p-4 outline-none duration-300" type="email" placeholder="Enter your email address">
                                    </div>
                                </div>
                                <div class="grid gap-5 sm:gap-6 w-full lg:w-1/2">
                                    <div>
                                        <label class="text-base md:text-lg text-title dark:text-white leading-none mb-2 sm:mb-3 block">Location</label>
                                        <input v-model="form.address_line" class="w-full h-12 md:h-14 bg-white dark:bg-dark-secondary border border-[#E3E5E6] text-title dark:text-white focus:border-primary p-4 outline-none duration-300" type="text" placeholder="Enter your location">
                                    </div>
                                    <div>
                                        <label class="text-base md:text-lg text-title dark:text-white leading-none mb-2 sm:mb-3 block">City</label>
                                        <input v-model="form.city" class="w-full h-12 md:h-14 bg-white dark:bg-dark-secondary border border-[#E3E5E6] text-title dark:text-white focus:border-primary p-4 outline-none duration-300" type="text" placeholder="Enter your city">
                                    </div>
                                    <div>
                                        <label class="text-base md:text-lg text-title dark:text-white leading-none mb-2 sm:mb-3 block">Country</label>
                                        <input v-model="form.country" class="w-full h-12 md:h-14 bg-white dark:bg-dark-secondary border border-[#E3E5E6] text-title dark:text-white focus:border-primary p-4 outline-none duration-300" type="text" placeholder="Enter your country">
                                    </div>
                                </div>
                            </div>
                            <p v-if="message" class="mt-6 text-sm text-[#31A051]">{{ message }}</p>
                            <p v-if="generalError" class="mt-6 text-sm text-[#E13939]">{{ generalError }}</p>
                            <div class="mt-5 sm:mt-8 md:mt-12">
                                <button class="btn btn-solid" data-text="Save Change" :disabled="saving">
                                    <span>{{ saving ? 'Saving...' : 'Save Change' }}</span>
                                </button>
                            </div>
                        </form>

                        <form class="w-full max-w-[951px] bg-[#F8F8F9] dark:bg-dark-secondary p-5 sm:p-8 lg:p-[50px] mt-8" @submit.prevent="savePassword">
                            <div class="flex items-center justify-between gap-4 flex-wrap mb-6">
                                <h4 class="font-semibold leading-none text-xl md:text-2xl">Change Password</h4>
                                <span class="text-sm text-paragraph dark:text-white-light">Use at least 8 characters.</span>
                            </div>
                            <div class="grid gap-5 sm:gap-6">
                                <div>
                                    <label class="text-base md:text-lg text-title dark:text-white leading-none mb-2 sm:mb-3 block">Current Password</label>
                                    <input v-model="passwordForm.current_password" class="w-full h-12 md:h-14 bg-white dark:bg-dark-secondary border border-[#E3E5E6] text-title dark:text-white focus:border-primary p-4 outline-none duration-300" type="password" placeholder="Enter your current password">
                                    <p v-if="passwordErrors.current_password" class="mt-2 text-sm text-[#E13939]">{{ passwordErrors.current_password }}</p>
                                </div>
                                <div>
                                    <label class="text-base md:text-lg text-title dark:text-white leading-none mb-2 sm:mb-3 block">New Password</label>
                                    <input v-model="passwordForm.password" class="w-full h-12 md:h-14 bg-white dark:bg-dark-secondary border border-[#E3E5E6] text-title dark:text-white focus:border-primary p-4 outline-none duration-300" type="password" placeholder="Enter your new password">
                                    <p v-if="passwordErrors.password" class="mt-2 text-sm text-[#E13939]">{{ passwordErrors.password }}</p>
                                </div>
                                <div>
                                    <label class="text-base md:text-lg text-title dark:text-white leading-none mb-2 sm:mb-3 block">Confirm New Password</label>
                                    <input v-model="passwordForm.password_confirmation" class="w-full h-12 md:h-14 bg-white dark:bg-dark-secondary border border-[#E3E5E6] text-title dark:text-white focus:border-primary p-4 outline-none duration-300" type="password" placeholder="Re-enter your new password">
                                </div>
                            </div>
                            <p v-if="passwordMessage" class="mt-6 text-sm text-[#31A051]">{{ passwordMessage }}</p>
                            <p v-if="passwordGeneralError" class="mt-6 text-sm text-[#E13939]">{{ passwordGeneralError }}</p>
                            <div class="mt-5 sm:mt-8 md:mt-12">
                                <button class="btn btn-solid" data-text="Update Password" :disabled="passwordSaving">
                                    <span>{{ passwordSaving ? 'Updating...' : 'Update Password' }}</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <FooterOne/>
        <ScrollToTop/>        

    </div>
</template>

<script setup>
    import { onMounted, reactive, ref, watch } from 'vue';
    import NavbarOne from '@/components/navbar/navbar-one.vue';
    import FooterOne from '@/components/footer/footer-one.vue';
    import ProfileTab from '@/components/profile-tab.vue';
    import ScrollToTop from '@/components/scroll-to-top.vue';
    import bg from '@/assets/img/shortcode/breadcumb.jpg'
    import Aos from 'aos';
    import { useClientSession } from '@/composables/use-client-session';

    const session = useClientSession();
    const saving = ref(false);
    const passwordSaving = ref(false);
    const generalError = ref('');
    const message = ref('');
    const passwordGeneralError = ref('');
    const passwordMessage = ref('');

    const form = reactive({
        name: '',
        email: '',
        phone: '',
        designation: '',
        address_line: '',
        city: '',
        country: '',
    });
    const passwordForm = reactive({
        current_password: '',
        password: '',
        password_confirmation: '',
    });
    const passwordErrors = reactive({
        current_password: '',
        password: '',
    });

    function syncForm(user) {
        form.name = user?.name || '';
        form.email = user?.email || '';
        form.phone = user?.phone || '';
        form.designation = user?.designation || '';
        form.address_line = user?.address_line || '';
        form.city = user?.city || '';
        form.country = user?.country || '';
    }

    async function saveChanges() {
        generalError.value = '';
        message.value = '';
        saving.value = true;

        try {
            await session.updateProfile(form);
            message.value = 'Profile updated successfully.';
        } catch (error) {
            generalError.value = error.message;
        } finally {
            saving.value = false;
        }
    }

    function resetPasswordFeedback() {
        passwordGeneralError.value = '';
        passwordMessage.value = '';
        passwordErrors.current_password = '';
        passwordErrors.password = '';
    }

    async function savePassword() {
        resetPasswordFeedback();
        passwordSaving.value = true;

        try {
            await session.updatePassword(passwordForm);
            passwordMessage.value = 'Password updated successfully.';
            passwordForm.current_password = '';
            passwordForm.password = '';
            passwordForm.password_confirmation = '';
        } catch (error) {
            const errors = error.errors || {};
            passwordErrors.current_password = errors.current_password ? errors.current_password[0] : '';
            passwordErrors.password = errors.password ? errors.password[0] : '';
            passwordGeneralError.value = error.message;
        } finally {
            passwordSaving.value = false;
        }
    }

    watch(() => session.state.user, (user) => {
        syncForm(user);
    }, { immediate: true });

    onMounted(async ()=>{
        Aos.init()
        await session.initializeSession();
        syncForm(session.state.user);
    })
</script>
